// extracted by mini-css-extract-plugin
export default {"cart_ingredients":"CartIngredients_cart_ingredients__IL5gv"};